import { jsx as _jsx } from "react/jsx-runtime";
import { getSlateColorToken } from "@faire/retailer-shared/SlateMappings/getSlateColorToken";
import { getResponsiveSpacingPixels } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/Styling/spacing";
import { assignInlineVars, mapResponsivePropToCSSVars } from "@faire/retailer-visitor-shared/lib/tailwindUtils";
import { HorizontalLine } from "@faire/web--source/slate/Layout";
import classNames from "classnames";
import React from "react";
var varMobileHeight = {
    variable: "--f-sdui-spacer",
    className: "min-h-(--f-sdui-spacer) basis-(--f-sdui-spacer)"
};
var varTabletHeight = {
    variable: "--f-sdui-spacer-md",
    className: "md:min-h-(--f-sdui-spacer-md) md:basis-(--f-sdui-spacer-md)"
};
var varDesktopHeight = {
    variable: "--f-sdui-spacer-lg",
    className: "lg:min-h-(--f-sdui-spacer-lg) lg:basis-(--f-sdui-spacer-lg)"
};
var varXLargeHeight = {
    variable: "--f-sdui-spacer-xl",
    className: "xl:min-h-(--f-sdui-spacer-xl) xl:basis-(--f-sdui-spacer-xl)"
};
export var SDUISpacerRenderer = function(param) {
    var component = param.component;
    var spacerComponent = component.spacer_component;
    if (!spacerComponent) {
        return null;
    }
    var vertical_spacing = spacerComponent.vertical_spacing, responsive_vertical_spacing = spacerComponent.responsive_vertical_spacing, style = spacerComponent.style;
    var variant = style === null || style === void 0 ? void 0 : style.variant;
    var responsiveValues = getResponsiveSpacingPixels(vertical_spacing, responsive_vertical_spacing);
    if (!variant || !responsiveValues.mobileAndAbove) {
        return null;
    }
    var _mapResponsivePropToCSSVars = mapResponsivePropToCSSVars(responsiveValues, {
        mobileAndAbove: varMobileHeight,
        tabletAndAbove: varTabletHeight,
        desktopAndAbove: varDesktopHeight,
        xLargeAndAbove: varXLargeHeight
    }), heightVars = _mapResponsivePropToCSSVars.vars, heightClasses = _mapResponsivePropToCSSVars.classes;
    return /*#__PURE__*/ _jsx("div", {
        "data-test-id": "sdui-spacer",
        className: classNames("flex flex-col justify-center", heightClasses),
        style: assignInlineVars(heightVars),
        children: variant === "HORIZONTAL_LINE" ? /*#__PURE__*/ _jsx(HorizontalLine, {
            color: (style === null || style === void 0 ? void 0 : style.color) !== undefined ? getSlateColorToken(style.color) : undefined
        }) : null
    });
};
